class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack};
/* tjs <- string-case.ts */

/* line 1 */
export function camelToKabob(s) {
  try {
  __tjs.pushStack('string-case.ts:4:camelToKabob');
  if (s instanceof Error) return s;
  if (typeof s !== 'string') return __tjs.typeError('string-case.ts:4:camelToKabob.s', 'string', s);

    return s.replace(/[A-Z]/g, (c) => {
        return `-${c.toLocaleLowerCase()}`;
    });

  } finally { __tjs.popStack(); }
}
camelToKabob.__tjs = {
  "params": {
    "s": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "string-case.ts:4"
}

/* line 7 */
export function kabobToCamel(s) {
  try {
  __tjs.pushStack('string-case.ts:11:kabobToCamel');
  if (s instanceof Error) return s;
  if (typeof s !== 'string') return __tjs.typeError('string-case.ts:11:kabobToCamel.s', 'string', s);

    return s.replace(/-([a-z])/g, (_, c) => {
        return c.toLocaleUpperCase();
    });

  } finally { __tjs.popStack(); }
}
kabobToCamel.__tjs = {
  "params": {
    "s": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "string-case.ts:11"
}